<template>
  <div>
    <VueSignaturePad v-if="mounted" ref="signaturePad" class="signature-pad" width="540px" height="250px" />
    <div class="is-vertical-center mt-5">
      <b-button class="mr-2" icon-left="undo" @click="undo" />
      <b-button type="is-primary" icon-left="check" @click="save">
        {{ $t("signDoc") }}
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "Signatur",
  components: {},
  data() {
    return {
      mounted: false,
    };
  },
  mounted() {
    this.mounted = true;
    setTimeout(() => {
      document.querySelector(".signature-pad canvas").setAttribute("width", "540px");
      document.querySelector(".signature-pad canvas").setAttribute("height", "250px");
    }, 1000);
  },
  methods: {
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (!isEmpty) {
        this.$emit("signed", data);
      }
      console.log(isEmpty);
      console.log(data);
    },
  },
};
</script>

<style scoped>
.signature-pad {
  width: 100% !important;
  max-width: 100%;
  border: 2px solid #303030;
}
.is-vertical-center {
  text-align: center;
}
</style>
